import { OnboardingFlows } from '@/pages/onboarding/steps';
import { IUserSettingsData } from '@d-id/types';

export const InitialState = () => ({
    ...Object.values(OnboardingFlows).reduce(
        (acc, curr) => {
            acc[curr] = '';
            return acc;
        },
        {} as Record<OnboardingFlows, string>
    ),
});

export const defaultIUserSettings: IUserSettingsData = {
    features: {
        onBoarding: {
            answers: {
                step: 0,
                state: {},
            },
            dialogSeen: false,
            finished: false,
        },
        editor: {
            popupSeen: false,
            switchBackSurveySeen: false,
        },
        termsAccepted: {
            accepted: false,
            acceptedAt: undefined,
        },
    },
    messages: {
        creditMigrationSeen: false,
    },
    preferences: {},
    experiments: {},
};

export function fillDBObjectWithDefaultValuesIfEmpty(settings: IUserSettingsData | undefined): IUserSettingsData {
    return {
        features: settings?.features || {},
        messages: settings?.messages || {},
        preferences: settings?.preferences || {},
        experiments: settings?.experiments || {},
    };
}
